import Page from "../../components/Page";

export default function Article() {
  return (
    <Page title="The He(art) of Gentle Persuasion">
      <p>
        {" "}
        <b>The He(art) of Gentle Persuasion</b>(Published February, 2012, in On
        Purpose Woman magazine){" "}
      </p>
      <p>
        by<b> Don Robertson</b>
      </p>
      <br />
      <p>
        I can still recall my early childhood years, and the special place that
        animals held in my heart. And I remember how stunned and saddened I was
        to learn the awful truth - that we kill animals for food.
      </p>
      <br />
      <p>
        Vegetarians had gained my admiration early on for the special effort
        they make to help animals each day. I understood the important role they
        play in demonstrating to us that people can be healthy without eating
        meat.
      </p>
      <br />
      <p>
        But I didn't give serious attention to those ideas until I was 41 and
        saw pictures showing the terrible living conditions we impose on farmed
        animals today. And I knew that I was part of the problem.
      </p>
      <br />
      <p>
        So I began reading about vegetarianism and was surprised to learn how
        much healthier a plant-based diet is than standard American fare. I was
        even more surprised, and greatly disturbed, to learn how inefficient
        modern animal agriculture is: it takes 14-16 lbs. of grains to produce
        just one pound of beef. As a result of Americans' meat habit, 80% of our
        farmlands are now used to grow crops to feed "livestock" rather than
        people. If we stopped breeding animals for food and grew only crops for
        human consumption, we could feed 5-7 times the number of people we now
        feed.
      </p>
      <br />
      <p>
        I was convinced… gradually shifted toward the veg lifestyle, and went
        vegan a year later. That change started a wonderfully fulfilling new
        chapter of my life. It felt really good to know that my lifestyle was in
        tune with my values. And I wanted to do all that I could to educate and
        inspire others to adopt this healthy, peaceful way of life.
      </p>
      <br />
      <p>
        So I promoted my new found "religion" with evangelical fervor. There was
        no conversation that I couldn't redirect toward my favorite topic. And I
        just knew that if I gave people enough information, I'd soon have a long
        list of "converts".
      </p>
      <br />
      <p>
        But my outreach efforts didn't give me the results I desired. I was too
        busy giving people the information I thought they needed to let them
        tell me what they actually needed. And I would often continue my
        monologues long after their ears had slammed shut. No one but my mom
        wanted to be around me. And I think the problem was that I was more
        concerned with my own success and status as "vegetarianism expert" than
        in connecting with and supporting others.
      </p>
      <br />
      <p>
        It took me years to learn that the best way to promote peace,
        compassion, and justice is to "Be the Peace"... to be a living example
        of those values. But that takes time and patience; and advocates may
        feel an overriding sense of urgency because we know that innocent lives
        are at stake.
      </p>
      <br />
      <p>
        Our sadness and grief can sometimes surface as anger and impatience. We
        may feel more inclined to judge and punish non-vegetarians than to
        educate them. We can be arrogant and self-righteous, and can imagine
        that we know better than they what their priorities should be. We can
        criticize or shun those whose lifestyles don't meet our strict
        definition of "vegan", or those whose reasons for going vegetarian
        aren't the "right" ones. But I don't think that's in keeping with the
        spirit of veganism, which at best is about kindness, understanding, and
        generosity.
      </p>
      <br />
      <p>
        Animal advocates would do well to consider the powerful difference our
        attitude can make in conversations with others. We can choose to talk
        down to them, and play the role of critical and controlling parent, or
        we can do our best to be a friend and supporter. That would require in
        us a willingness to listen patiently without judgment, to stop looking
        for perfection, and to applaud every step in the right direction. We
        also need to do our inner work and continue letting go of control,
        anger, blame, and any other aspect of our character that is inconsistent
        with kindness.
      </p>
      <br />
      <p>
        {" "}
        I see the growing veg-vegan-animal protection movement as the next step
        in human evolution. Vegan philosophy is beautifully aligned with our
        most deeply held and shared spiritual values.*1 The prevailing world
        view - in which the earth and persons of other species are regarded
        merely as resources and commodities - has lent itself to a profound
        spiritual disconnection, and has brought us to the edge of environmental
        collapse.*2
      </p>
      <br />
      <p>
        Where we will go from here is yet to be decided. My hope and most deeply
        held prayer is that I may use my time and energy in service to all… and
        that my life may honor and affirm my connection to the earth and to all
        living beings… and might mirror the Gratitude I feel for the wonderful
        and sacred Gift of Life.
      </p>
      <br />
      <hr />
      <br />
      <p>
        {" "}
        *1. Whereas vegetarians avoid eating animal flesh, and thus exclude all
        meat, fish, and fowl from their diet, vegans try to avoid eating,
        wearing, or using any products that were derived from animals or that
        involve animal exploitation. So their diet is free of animal flesh,
        dairy products, and eggs.
      </p>
      <br />
      <p>
        *2. A 2006 U.N. report, “Livestock’s Long Shadow”, pointed to animal
        agriculture as the primary source of climate changing greenhouse gases,
        its effects more damaging than all forms of transportation combined.
      </p>
      <br />
      <p>
        <b>Don Robertson</b> is founding director of the nonprofit group{" "}
        <b>Earthsave Baltimore</b>, which hosts a monthly educational vegan
        dinner series in Owings Mills and two monthly vegetarian discussion
        groups, one in Towson, and one in Pikesville. He offers supportive
        information and advice on diet and lifestyle change at , on his Facebook
        page as Earthsaverdon, and on the Facebook group page for Earthsave
        Baltimore.
      </p>
    </Page>
  );
}
